module.exports = __webpack_public_path__ + "img/portfolio_8.5a9c55ef.jpg";